/**
 * Common constants
 */

export const GAME_NAME_CHAR_LIMIT = 20;
export const GAME_DESCRIPTION_CHAR_LIMIT = 110;
export const GAME_DESCRIPTION_MIN_LENGTH = 20;
export const GAME_KEYWORDS_CHAR_LIMIT = 100;
export const NOTIFICATION_CTA_CHAR_LIMIT = 50;
export const NOTIFICATION_TITLE_CHAR_LIMIT = 200;
export const NOTIFICATION_BODY_CHAR_LIMIT = 2000;
// RFC 8291 §4: plaintext a push service accepts for a single aes128gcm record.
export const WEB_PUSH_MAX_PAYLOAD_BYTES = 3993;

// The play CTA on every game card surface, shared so the Explore card, the
// recommended row and the console's campaign preview cannot drift apart.
export const GAME_CARD_PLAY_CTA = "Play now";

/** 1-based Explore feed positions holding a promoted card, in auction order. */
export const EXPLORE_FEED_PROMOTED_SLOTS = [1, 4] as const;

export const AVAILABLE_AVATARS = 1000;
export const MAX_NOTIFICATION_SCHEDULE_DAYS = 7;
// Same-day schedules are allowed; a time sooner than this floor is moved up to it.
export const MIN_NOTIFICATION_SCHEDULE_MINUTES = 10;
export const MIN_NOTIFICATION_SCHEDULE_MS =
  MIN_NOTIFICATION_SCHEDULE_MINUTES * 60 * 1000;

export const NOTIFICATION_INLINE_ASSET_MAX_BASE64_LENGTH = 2 * 1024 * 1024;
export const NOTIFICATION_INLINE_ASSET_MIME_PATTERN =
  /^data:image\/(png|jpeg|webp);base64,/;
export const NOTIFICATION_ASSET_URL_PATTERN = /^https:\/\/\S+$/;
export const NOTIFICATION_ASSET_URL_MAX_LENGTH = 2048;

// Interactive notifications (multi-message "This or That"-style flows).
export const MAX_INTERACTIVE_MESSAGES = 15;
export const MAX_INTERACTIVE_OPTIONS_PER_MESSAGE = 6;
export const INTERACTIVE_OPTION_KEY_MAX = 32;
// Reserved entryPayload key holding the picks made in the thread. Game-facing.
export const INTERACTIVE_PICKS_KEY = "interactivePicks";

export const CLOUDFLARE_IMAGE_PROXY = "https://cdn.jestpub.com/cdn-cgi/image/";

export const JEST_FUND_URL = "https://about.jest.com/fund";

// How long a registration lease stays claimable; shared so the client can reuse its own.
export const REGISTRATION_LEASE_TTL_MINUTES = 60;

// Short of that TTL, which started before the client observed the response.
export const REGISTRATION_LEASE_REUSE_WINDOW_MS =
  REGISTRATION_LEASE_TTL_MINUTES * 60_000 - 60_000;

// Caps game-authored registration text at a conservative GSM character budget.
export const REGISTRATION_MESSAGE_CHAR_LIMIT = 140;
// What the placeholder is worth once filled in, so limits count the real text.
export const REGISTRATION_CODE_LENGTH = 6;
// A single UCS-2 SMS carries 70 UTF-16 code units.
export const REGISTRATION_MESSAGE_UNICODE_CHAR_LIMIT = 70;
// A single GSM-7 SMS carries 160 septets, extended characters costing two.
export const REGISTRATION_PREFILL_SEGMENT_LIMIT = 160;
export const REGISTRATION_CODE_PLACEHOLDER = "{{registrationCode}}";

/** Bump with every Terms of Service update: accounts on an older version see the update notice. */
export const TERMS_VERSION = "2026-10-11";
